export default __webpack_public_path__ + "static/scientist-male-2e8106dbb193b7c0d3319cae94520da7.png";